/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EventContentDto
 */
export interface EventContentDto {
    /**
     * 
     * @type {string}
     * @memberof EventContentDto
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof EventContentDto
     */
    value?: string;
}

/**
 * Check if a given object implements the EventContentDto interface.
 */
export function instanceOfEventContentDto(value: object): value is EventContentDto {
    return true;
}

export function EventContentDtoFromJSON(json: any): EventContentDto {
    return EventContentDtoFromJSONTyped(json, false);
}

export function EventContentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventContentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'] == null ? undefined : json['key'],
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function EventContentDtoToJSON(json: any): EventContentDto {
    return EventContentDtoToJSONTyped(json, false);
}

export function EventContentDtoToJSONTyped(value?: EventContentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'value': value['value'],
    };
}

